import { Inject, inject, Injectable } from '@angular/core';
import { EMPTY, Subscription, switchMap, timer } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { API_URL_V2 } from '../injection/environment';

@Injectable({
	providedIn: 'root',
})
export class LoginLoggerService {
	private http: HttpClient = inject(HttpClient);
	private loggingSubscription?: Subscription;

	constructor(@Inject(API_URL_V2) private apiUrlV2: string) {}

	startLoginLogging(userId: string): void {
		if (this.loggingSubscription) {
			return;
		}

		this.loggingSubscription = timer(0, 5 * 60 * 1000)
			.pipe(
				/*
				tap(() => {
				})
		 	*/
				switchMap(() =>
					this.http.post(`${this.apiUrlV2}account/heartbeat`, { platform: 'infoday' }).pipe(
						catchError((error: HttpErrorResponse) => {
							console.error('Logging request failed', error);
							return EMPTY;
						})
					)
				)
			)
			.subscribe();
	}

	stopLoginLogging(): void {
		this.loggingSubscription?.unsubscribe();
		this.loggingSubscription = undefined;
	}
}
